<template>
  <div id="about">
    <CommonHeader></CommonHeader>
    <div class="banner">
      <img src="/images/banner2.png" />
    </div>
    <div class="main7 wrap clearfix">
      <div class="main7-left">
        <div class="main7-left-title">
          <span v-for="(item, index) in main7.header" :key="index" :class="'main7-title'+index" v-text="item.title"></span>
        </div>
        <ul>
          <li @click="toggle($index)" v-for="(tab, $index) in main7.body" :key="$index"  v-text="tab.title"></li>
        </ul>
      </div>
      <div class="main7-right">
        <div class="main7-right-title">
          当前位置：<a href="/">首页</a> <span>&gt;</span><router-link :to="goto" v-text="about"></router-link> <span>&gt;</span> <strong v-for="(tab, $index) in main7.body" :key="$index" :class="{active: active === $index}"  v-text="tab.title"></strong>
        </div>
        <div class="main7-right-content">
          <ul>
            <li v-for="(tab, $index) in main7.body" :key="$index" :class="{active: active === $index}">
              <h4 v-text="tab.title"></h4>
              <p v-text="tab.content"></p>
            </li>
          </ul>
          <!-- <div class="imgs" :class="{active: active === 2}">
            <h3>营业执照</h3>
            <div class="img-wrap">
              <img src="/images/img-license-changxue.jpg">
            </div>
            <h3>广播电视节目制作经营许可证</h3>
            <div class="img-wrap">
              <img src="/images/img-broadcasting-license.jpg">
            </div>
          </div> -->
        </div>
      </div>
    </div>
    <CommonFooter></CommonFooter>
  </div>
</template>

<script>
import CommonHeader from "@/components/CommonHeader.vue"
import CommonFooter from "@/components/CommonFooter.vue"

export default {
  name: "about",
  components: {
    CommonHeader,
    CommonFooter
  },

  data() {
    return {
      main7: {
        header: [],
        body: [],
      },
      about: '',
      goto: '',
      active: 0,
    }
  },

  created() {
    this.loadData();
  },

  methods: {
    loadData() {
      this.$http
        .get("/data/about.json")
        .then(response => {
          if (response.data) {
            this.main7.header = response.data.main7.header;
            this.main7.body = response.data.main7.body;

            this.about = response.data.main7.about;
            this.goto = response.data.main7.goto;
          }
        })
        .catch(err => {
          console.log(err);
        })
    },
    toggle(i) {
      this.active = i;
    }
  }
};
</script>

<style lang="less">
.banner {
  width: 100%;

  img {
    width: 100%;
    height: auto;
  }
}

.main7 {
  margin: 50px auto;
  min-height: 400px;

  .imgs {
    display: none;
  }

  .active {
    display: inline-block;
  }

  .main7-left {
    float: left;
    width: 180px;

    .main7-left-title {
      span {
        display: block;
        width: 180px;
        height: 79px;
        font-weight: bold;
        text-align: center;
        letter-spacing: 1px;
        color: #fff;
        background: #5Cadff;
      }

      .main7-title0 {
        padding-top: 45px;
        font-size: 24px;
      }

      .main7-title1 {
        font-size: 20px;
      }
    }

    ul {
      li {
        padding-left: 30px;
        border-right: solid 1px #999;
        border-bottom: solid 1px #999;
        line-height: 2.8;
        font-size: 16px;
        color: #666;
        cursor: pointer;

        &:before {
          display: inline-block;
          content: '';
          position: relative;
          left: -10px;
          bottom: 2px;
          width: 5px;
          height: 5px;
          background: #666;
        }
      }
    }
  }

  .main7-right {
    float: left;
    width: 900px;
    margin-left: 49px;

    .main7-right-title {
      padding: 10px 0 25px;
      border-bottom: solid 2px #5cadff;
      color: #999;
      cursor: pointer;

      a {
        color: #999;
      }

      span {
        padding: 0 10px;
      }
    }

    .main7-right-content {
      h4 {
        padding: 28px 0 47px;
        font-weight: bold;
        font-size: 24px;
        color: #333;
      }

      p {
        line-height: 2;
        font-size: 16px;
        color: #666;
      }

      h3 {
        padding-top: 30px;
        line-height: 2.5;
        text-align: center;
      }

      .img-wrap {
        text-align: center;

        img {
          max-width: 80%;
          height: auto;
        }
      }
    }
  }
}

.main7-right strong,
.main7-right-content li {
  display: none;
}
</style>
